export default __webpack_public_path__ + "static/media/02.24aafe1e.jpg";